import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import * as fromAppRoot from '@app/app.reducers';

import { MOBILE_APP } from '@app/app.constants';
import { LanguageService } from '@shared/services/language.service';

@Component({
  selector: 'app-grow-account',
  templateUrl: './grow-account.component.html',
  styleUrls: ['./grow-account.component.scss'],
  standalone: false
})
export class GrowAccountComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  stepStatus: number;

  playStoreBadgeSource: string;
  appleStoreBadgeSource: string;
  readonly appLinks = MOBILE_APP;

  constructor(
    private store: Store,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.languageService.selected.pipe(takeUntil(this.onDestroy$)).subscribe((lang) => {
      switch (lang) {
        case 'fr-CH':
          this.playStoreBadgeSource = 'assets/images/app-badges/GetItOnGooglePlay_Badge_FR.png';
          this.appleStoreBadgeSource = 'assets/images/app-badges/Download_on_the_App_Store_Badge_FR.png';
          break;
        case 'de-CH':
        case 'de-DE':
          this.playStoreBadgeSource = 'assets/images/app-badges/GetItOnGooglePlay_Badge_DE.png';
          this.appleStoreBadgeSource = 'assets/images/app-badges/Download_on_the_App_Store_Badge_DE.png';
          break;
        default:
          this.playStoreBadgeSource = 'assets/images/app-badges/GetItOnGooglePlay_Badge_EN.png';
          this.appleStoreBadgeSource = 'assets/images/app-badges/Download_on_the_App_Store_Badge_EN.png';
          break;
      }
    });

    this.store
      .select(fromAppRoot.selectCurrentAccount)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        this.stepStatus = value.step_status;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
